import React, { useContext, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import Pagereview from "../../components/pageReview/Pagereview";
import "swiper/css";
import "swiper/css/navigation";

import "./swiper.css";
import { FormContext } from "../CMSRenderer/CMSRenderer";

const OverviewHealthinDubai = ({ config }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const { currentLang } = useContext(FormContext);

  const active = config.timelineData[activeIndex];

  return (
    <>
      {/* <dda-breadcrumb
        design="text"
        separator="chevron_right"
        custom_class=""
        component_mode=""
        data-breadcrumbs='[{"text":"Home","icon":"home","url":"/"},{"text":"Health in Dubai","icon":"menu_book","url":"/healthdubai"}]'
      ></dda-breadcrumb> */}
      <h2 className="mb-4 Medium  text-primary">
        {currentLang === "en" ? config.title : config.title_ar}
      </h2>

      <h5 className="mb-4 Medium  text-primary">
        {currentLang === "en" ? config.subtitle : config.subtitle_ar}
      </h5>

      <div className="w-full flex flex-col items-center px-4 py-10 bg-white">
        <Swiper
          modules={[Navigation]}
          lazy={true}
          onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
          navigation={{ clickable: true }}
          initialSlide={0}
          centeredSlides
          slidesPerView={3}
          spaceBetween={0}
          className="w-full"
          breakpoints={{
            320: { slidesPerView: 1 },
            768: { slidesPerView: 3 },
          }}
        >
          {config.timelineData.map((item, idx) => (
            <SwiperSlide key={item.year} className="flex justify-center">
              <div className="item-main w-full flex flex-col gap-4 justify-center items-center pb-1 pt-2 relative">
                
                {/* Image */}
                {/* <div className="h-80 flex items-end">
                  <img
                    src={item.image}
                    alt={
                      currentLang === "en"
                        ? item.cards[0]?.title
                        : item.cards[0]?.title_ar || ""
                    }
                    className={`object-cover rounded-lg shadow-md transition-all duration-300 z-10 ${
                      idx === activeIndex
                        ? "w-[400px] h-80 scale-100"
                        : "w-[300px] h-48 opacity-40 scale-90"
                    }`}
                  />
                </div> */}
                <div className="">
                  <div
                    className={`absolute bottom-[32px] ${
                      idx === 0 ? "w-[50%] [inset-inline-end:0px]" : "[inset-inline-start:0px]"
                    } ${
                      idx === config.timelineData.length - 1 ? "w-[50%]" : ""
                    }  h-0.5 bg-primary z-0`}
                  />
                  
                  <div
                    className={`relative rounded-full border-2  text-center font-semibold transition-all z-10 ${
                      idx === activeIndex
                        ? `${item.color} border-4 bg-white scale-110 w-20 h-20 pt-6 text-xl`
                        : "border-primary bg-customSurface w-14 h-14 body pt-3"
                    }`}
                  >
                    {item.year}
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="flex flex-col items-center w-full mt-[23px] gap-4">
          {active.cards.map((card, i) => (
            <div
              key={i}
              className={`bg-white border-[3px] ${
                i === 0 ? `${card.color1}` : `${card.color2}`
              } rounded-2xl p-6 text-center text-onSurfaceVariant w-full max-w-sm mb-[18px] `}
            >
              {card.title && (
                <h5 className="Regular mb-1">
                  {currentLang === "en" ? card.title : card.title_ar}
                </h5>
              )}
              {card.description && (
                <h5 className="mb-1">
                  {currentLang === "en"
                    ? card.description
                    : card.description_ar}
                </h5>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="border brorder-outline w-fit m-auto hidden gap-5 p-2 rounded-xl">
        <div className="flex gap-2 items-center">
          <div className="w-8 h-4 rounded-full bg-[#80bc00]"></div>
          <p className="body text-onSurfaceVariant">
            {currentLang === "en" ? config.chip : config.chip_ar}
          </p>
        </div>
        <div className="flex gap-2 items-center">
          <div className="w-8 h-4 rounded-full bg-primary"></div>
          <p className="body text-onSurfaceVariant">
            {currentLang === "en" ? config.chip_1 : config.chip_1_ar}
          </p>
        </div>
        <div className="flex gap-2 items-center">
          <div className="w-8 h-4 rounded-full bg-outline"></div>
          <p className="body text-onSurfaceVariant">
            {currentLang === "en" ? config.chip_2 : config.chip_2_ar}
          </p>
        </div>
      </div>
      
    </>
  );
};

export default OverviewHealthinDubai;
